import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import omit from 'lodash/omit';

export const transformCatalogDataObj = (data) => keyBy(data, 'name');

export const transformCatalogDataList = (data) => data.map((d) => ({ name: d.name }));

export const transformCatalogItemsDataList = (data) => data.map((k) => ({ name: k.key }));

export const transformCatalogItemsDataObj = (data) => keyBy(data, 'key');

export const transformCatalogItemValueDataObj = (data) => ({
  [data.table]: {
    [data.key]: {
      ...omit(data, ['table', 'value']),
      value: JSON.stringify(data.value),
    },
  },
});

export const mergeCatalogItemsAndReplaceValues = ({ dataObj, tableName, resp }) => {
  const mergedItems = get(dataObj, tableName, {});
  resp.forEach((d) => {
    const { key } = d;
    mergedItems[key] = d;
  });

  return {
    ...dataObj,
    [tableName]: mergedItems,
  };
};

export const isAlphanumeric = (text) => {
  const re = /^[a-zA-Z0-9-]+$/;
  return text.search(re) === 0;
};
